export const SEPARATOR_CHARACTER_SLASH = "/";
